import get from 'lodash/get';
import {
  FETCH_GOOGLE_MAPS_STATIC_URL_REQUEST,
  FETCH_GOOGLE_MAPS_STATIC_URL_SUCCESS,
  FETCH_GOOGLE_MAPS_STATIC_URL_FAILURE
} from 'base/actions/actionTypes';

const initialState = {
  staticUrls: [],
  isFetching: false,
  error: ''
};

const googleMapsStaticUrlReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_GOOGLE_MAPS_STATIC_URL_REQUEST}`: {
      return {
        ...state,
        isFetching: true,
        error: ''
      };
    }
    case `${FETCH_GOOGLE_MAPS_STATIC_URL_SUCCESS}`: {
      return {
        ...state,
        staticUrls: [get(action, 'payload'), ...state.staticUrls],
        isFetching: false,
        error: ''
      };
    }
    case `${FETCH_GOOGLE_MAPS_STATIC_URL_FAILURE}`: {
      return {
        ...state,
        isFetching: false,
        error: get(action, 'payload.message')
      };
    }
    default:
      return state;
  }
};

export default googleMapsStaticUrlReducer;
